var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceOfIssue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3C4.34375 3 3 4.375 3 6C3 7.65625 4.34375 9 6 9C7.625 9 9 7.65625 9 6C9 4.375 7.625 3 6 3ZM6 8C4.875 8 4 7.125 4 6C4 4.90625 4.875 4 6 4C7.09375 4 8 4.90625 8 6C8 7.125 7.09375 8 6 8ZM6 0C2.65625 0 0 2.6875 0 6C0 8.4375 0.8125 9.125 5.375 15.6875C5.65625 16.125 6.3125 16.125 6.59375 15.6875C11.1562 9.125 12 8.4375 12 6C12 2.6875 9.3125 0 6 0ZM6 14.8125C1.625 8.53125 1 8.03125 1 6C1 4.6875 1.5 3.4375 2.4375 2.46875C3.40625 1.53125 4.65625 1 6 1C7.3125 1 8.5625 1.53125 9.53125 2.46875C10.4688 3.4375 11 4.6875 11 6C11 8.03125 10.3438 8.53125 6 14.8125Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceOfIssue);
export default __webpack_public_path__ + "static/media/place_of_issue.7df053be.svg";
export { ForwardRef as ReactComponent };